import React, { createContext, useContext, useState } from 'react';

const EditorContext = createContext();

export function EditorProvider({ children }) {
  const [editorContent, setEditorContent] = useState('');
  const [editorTitle, setEditorTitle] = useState('');
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedSummary, setSelectedSummary] = useState('');
  
  // Store parent callbacks
  const [parentCallbacks, setParentCallbacks] = useState({});

  const value = {
    // Content
    editorContent,
    setEditorContent,
    
    // Title
    editorTitle,
    setEditorTitle,
    
    // AI Suggestions
    selectedTags,
    setSelectedTags,
    selectedSummary,
    setSelectedSummary,
    
    // Parent callbacks
    parentCallbacks,
    setParentCallbacks,
    
    // Helper functions
    clearAllSelections: () => {
      setSelectedTags([]);
      setSelectedSummary('');
    },
    
    clearTitle: () => {
      setEditorTitle('');
      if (parentCallbacks.onTitleChange) {
        parentCallbacks.onTitleChange('');
      }
    },
    clearTags: () => setSelectedTags([]),
    clearSummary: () => setSelectedSummary(''),
    
    removeTag: (tagToRemove) => {
      setSelectedTags(prev => prev.filter(tag => tag !== tagToRemove));
    },
    
    selectTitle: (title) => {
      setEditorTitle(title);
      if (parentCallbacks.onTitleChange) {
        parentCallbacks.onTitleChange(title);
      }
    },
    selectTags: (tags) => setSelectedTags(tags),
    selectSummary: (summary) => setSelectedSummary(summary),
  };

  return (
    <EditorContext.Provider value={value}>
      {children}
    </EditorContext.Provider>
  );
}

export function useEditor() {
  const context = useContext(EditorContext);
  if (!context) {
    throw new Error('useEditor must be used within an EditorProvider');
  }
  return context;
}
